import { type Question } from '@/types'

import { generateId } from '../utils'
import { getQuestionByFormIndex } from './getQuestionByFormIndex'
import { getQuestionPosition } from './getQuestionPosition'
import { truncateText } from './truncateText'

export const getMatrixQuestionInfo = (
  questions: Question[],
  formIndex: string
) => {
  const fieldId = generateId()
  const cleanRowFormIndex = formIndex.replace('Q', '')

  const question = getQuestionByFormIndex(questions, cleanRowFormIndex)
  const position = getQuestionPosition(questions, cleanRowFormIndex)

  let title = 'Removed'
  if (question) title = question.text || 'Untitled'
  const description = [position, title].join('.')

  return {
    classes: question ? '' : 'removed',
    description,
    id: fieldId,
    title: truncateText(description),
    formIndex: cleanRowFormIndex,
  }
}
